import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export const AdminLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onSuccess(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-gb-white placeholder:text-gb-gray/50 transition-colors focus:border-gb-silver/50 focus:outline-none";

  return (
    <div className="grid-bg flex min-h-screen items-center justify-center bg-gb-black px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="card-chrome w-full max-w-sm rounded-2xl p-8" data-testid="admin-login-form">
        <div className="flex flex-col items-center text-center">
          <img src="/assets/logo.jpg" alt="Logotipo GOBAX" width={56} height={56} className="h-14 w-14 rounded-full ring-1 ring-white/20" />
          <h1 className="mt-5 font-display text-xl font-bold">Painel GOBAX</h1>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-gb-gray">Acesso restrito</p>
        </div>
        <div className="mt-8 space-y-4">
          <div>
            <label htmlFor="admin-email" className="mb-2 block font-mono text-[10px] uppercase tracking-[0.22em] text-gb-silver">E-mail</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required autoComplete="username" placeholder="admin@gobax.com.br" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-2 block font-mono text-[10px] uppercase tracking-[0.22em] text-gb-silver">Senha</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required autoComplete="current-password" placeholder="••••••••" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
        </div>
        {error && (
          <p data-testid="admin-login-error" role="alert" className="mt-4 rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-xs text-red-300">
            {error}
          </p>
        )}
        <button type="submit" disabled={loading} data-testid="admin-login-submit-btn" className="btn-chrome mt-7 inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold disabled:opacity-60">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : <Lock className="h-4 w-4" aria-hidden="true" />}
          Entrar
        </button>
      </form>
    </div>
  );
};
